import { pick } from 'lodash';

import { questionTypes } from 'sharedParts';
import {
  commentsProps,
  commonBlockProps,
} from 'sharedParts/config/blockConfig/getCommonBlockProps';

const commonBlockPropsList = Object.keys({
  ...commonBlockProps,
  ...commentsProps,
});

const commonCacheableFieldList = [
  ...commonBlockPropsList,
  'content',
  'plainText',
  'questionNumber',
];

const commonCacheableFieldListWithLabel = [
  ...commonCacheableFieldList,
  'label',
];

const optionCacheableFieldList = [...commonCacheableFieldList, 'options'];

const radioMultiCacheableFieldList = [...optionCacheableFieldList, 'layout'];

const imageCacheableFieldList = [
  ...radioMultiCacheableFieldList,
  'labelLayout',
  'personalLabelType',
  'size',
];

const matrixCacheableFieldList = [
  ...optionCacheableFieldList,
  'itemList',
  'labelAlignments',
];

const ratingCacheableFieldList = [
  ...commonCacheableFieldList,
  'size',
  'color',
  'segment',
  'itemList',
  'labelListEnd',
  'labelListEndMidpoint',
];

const numericCacheableFieldList = [
  ...ratingCacheableFieldList,
  'textColor',
  'startFromZero',
];

const blockCacheConfig = {
  [questionTypes.respondentCompanyName]: commonCacheableFieldList,
  [questionTypes.respondentFirstName]: commonCacheableFieldList,
  [questionTypes.respondentLastName]: commonCacheableFieldList,
  [questionTypes.respondentPhone]: commonCacheableFieldList,
  [questionTypes.respondentMail]: commonCacheableFieldList,
  [questionTypes.longText]: commonCacheableFieldList,
  [questionTypes.questionMatrixRadio]: matrixCacheableFieldList,
  [questionTypes.questionMatrixScale]: matrixCacheableFieldList,
  [questionTypes.questionMatrixMulti]: matrixCacheableFieldList,
  [questionTypes.questionImageSingle]: imageCacheableFieldList,
  [questionTypes.questionImageMulti]: imageCacheableFieldList,
  [questionTypes.questionSingle]: radioMultiCacheableFieldList,
  [questionTypes.questionDropdown]: optionCacheableFieldList,
  [questionTypes.questionMulti]: radioMultiCacheableFieldList,
  [questionTypes.questionScale]: ratingCacheableFieldList,
  [questionTypes.questionNumeric]: numericCacheableFieldList,
  [questionTypes.shortText]: commonCacheableFieldList,
  [questionTypes.respondentInfoMulti]: radioMultiCacheableFieldList,
  [questionTypes.respondentInfoRadio]: radioMultiCacheableFieldList,
  [questionTypes.respondentInfoDropdown]: optionCacheableFieldList,
  [questionTypes.respondentInfoLongText]: commonCacheableFieldListWithLabel,
  [questionTypes.respondentInfoShortText]: commonCacheableFieldListWithLabel,
};

export const pickCacheableFields = (data, type) =>
  pick(data, blockCacheConfig[type]);

export default blockCacheConfig;
